// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @ commons
const { DatePickerCustom } = require('commonsComponents/datePickerCustom');

// @ helpers
const { formatText, getLanguage } = require('core/i18n').i18n;

// @ constans
const { DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
const {
    MAX_DAYS_INSURANCE_INIT,
} = require('../../../../insuranceConstants/insuranceRequestHome');


const InsuranceRequestWizardStep4DatePicker = ({ immInsuranceWizardStep, onhandleDateChange }) => {
    const selectedDate = immInsuranceWizardStep.get('startDate') ? moment(immInsuranceWizardStep.get('startDate')) : null;
    const minDate = moment().startOf('day');
    const maxDay = immInsuranceWizardStep.getIn(['pricing', 'maxEffectiveStartDate']);
    const customMaxDay = maxDay !== undefined ? maxDay : MAX_DAYS_INSURANCE_INIT;
    const maxDate = moment(minDate).add(customMaxDay, 'days');
    const dateError = immInsuranceWizardStep.get('fieldErrors') && !immInsuranceWizardStep.get('startDate');

    return (
        <div className="insurance-request-wizard-step-four__payment-date">
            <DatePickerCustom
                id="insuranceStartDatePicker"
                callback={(event) => onhandleDateChange(event)}
                label={formatText('insuranceRequestHome-step4startDate')}
                minDate={minDate}
                maxDate={maxDate}
                language={getLanguage()}
                placeholder={formatText('datePickerCustom-placeholderDateFormat')}
                locale={DATE_PICKER_CUSTOM_LOCALE}
                dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                selectedDate={selectedDate}
                errorState={dateError}
                errorMessage={formatText('insuranceRequestHome-step4AdditionalInfoRequiredInput')}
            />
        </div>
    );
};

InsuranceRequestWizardStep4DatePicker.propTypes = {
    immInsuranceWizardStep: PropTypes.object.isRequired,
    onhandleDateChange: PropTypes.func.isRequired,
};

module.exports = InsuranceRequestWizardStep4DatePicker;
